import { render, staticRenderFns } from "./EgetaskBlock.vue?vue&type=template&id=178496dd&scoped=true"
import script from "./EgetaskBlock.vue?vue&type=script&lang=js"
export * from "./EgetaskBlock.vue?vue&type=script&lang=js"
import style0 from "./EgetaskBlock.vue?vue&type=style&index=0&id=178496dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178496dd",
  null
  
)

export default component.exports